module.exports = __webpack_public_path__ + "img/nodeType1.f22f634d.svg";